import { AxiosInstance, AxiosResponse } from 'axios'
import elasticsearchClient from './api'
import { environment, languageUrl, storeName } from '../Common'

// Define the types for the query structure
interface Suggestion {
  text: string
  term: {
    field: string
    suggest_mode: string
  }
}

interface Highlight {
  fields: {
    [key: string]: object
  } // Allow any field name with a value that can be any object
}

interface QueryStringQuery {
  regexp?: {
    [field: string]: {
      value: string
      case_insensitive: boolean
    }
  }
  bool?: {
    must: Array<
      | {
          query_string: {
            query: string
            fields: string[]
          }
        }
      | {
          regexp: {
            [field: string]: {
              value: string
              case_insensitive: boolean
            }
          }
        }
    >
    filter: Array<{
      terms: {
        [key: string]: string[]
      }
    }>
  }
}

interface QueryData {
  from: number
  size: number
  query: QueryStringQuery
  suggest: {
    'my-suggestion': Suggestion
  }
  highlight: Highlight
}

class SearchService {
  api: AxiosInstance

  constructor() {
    this.api = elasticsearchClient
  }

  // Define the method signature and return type as AxiosResponse
  search(
    searchValue: string,
    page: number = 1,
    perPage: number = 10,
    isSuggesyionQuery: boolean = false
  ): Promise<AxiosResponse> {
    // Base query structure

    // const searchResultElement = document.getElementById('searchResult')
    const languageArray = languageUrl ? languageUrl : 'en'

    // // Retrieve the value of the 'language' attribute
    // if (searchResultElement && searchResultElement.hasAttribute('language')) {
    //   const languages = searchResultElement.getAttribute('language') || ''
    //   if (languages) languageArray = languages?.split(',').map((lang) => lang?.trim())
    // }

    // approch for suggestion result and search result list
    let queryField = ['rendered_item^0.5', 'title^1']
    if (isSuggesyionQuery) queryField = ['title^1']

    // ✅ Always apply language filter
    const languageFilter = {
      terms: {
        search_api_language: [languageArray]
      }
    }

    // const queryData: QueryData = {
    //   from: (page - 1) * perPage,
    //   size: perPage,
    //   suggest: {
    //     'my-suggestion': {
    //       text: `.*${searchValue}.*`,
    //       term: {
    //         field: 'title',
    //         suggest_mode: 'always'
    //       }
    //     }
    //   },
    //   highlight: {
    //     fields: {
    //       '*': {}
    //     }
    //   },
    //   query: {
    //     regexp: {
    //       ['title.keyword']: {
    //         value: `.*${searchValue}.*`,
    //         case_insensitive: true
    //       }
    //     },
    //     filter: [languageFilter]
    //   }
    // }

    const queryData: QueryData = {
      from: (page - 1) * perPage,
      size: perPage,
      suggest: {
        'my-suggestion': {
          text: `.*${searchValue}.*`,
          term: {
            field: 'title',
            suggest_mode: 'always'
          }
        }
      },
      highlight: {
        fields: {
          '*': {}
        }
      },
      query: {
        bool: {
          must: [
            {
              regexp: {
                'title.keyword': {
                  value: `.*${searchValue}.*`,
                  case_insensitive: true
                }
              }
            }
          ],
          filter: [languageFilter]
        }
      }
    }

    // If searchValue is provided and is not empty, use query_string with fuzzy matching
    if (searchValue && searchValue.trim() !== '') {
      queryData.query = {
        bool: {
          must: [
            {
              query_string: {
                query: `${searchValue}~`, // Fuzzy matching query
                fields: queryField
              }
            }
          ],
          filter: [
            {
              terms: {
                search_api_language: [languageArray] // Filter by language (e.g., 'en' for English)
              }
            }
          ]
        }
      }
    }

    // Return the Axios request promise
    return this.api.post(
      `${environment ? (storeName ? `${environment}-general-${storeName}/_search?size=10` : `${environment}-general/_search?size=10`) : 'general/_search?size=10'}`,
      queryData
    )
  }
}

// Instantiate and export the SearchService class
const searchService = new SearchService()
export default searchService
